export const SEARCH_ENGINE_OPE_CODE = 'VPV_SEARCHENGI'
export const ORIGIN_URI_QUERY_PARAM_KEY = 'origin'
export const ORIGIN_TSF = 'tsf'
